// import $ from 'jquery';
import React from 'react';
import Field from './Field';
import {isEmpty} from "validator";
// import PropTypes from 'prop-types';

class FieldSelect extends Field {
    constructor(props) {
        super(props);
    }
    // format(value) {
    // }
    // validate() {
    // }
    handleClasses() {
        const { overrideDefaultClassName } = this.props;
        let fieldClassName = 'field--select';

        if (typeof overrideDefaultClassName !== 'undefined') {
            fieldClassName = overrideDefaultClassName;
        }

        const selected = this.getSelected();
        if (selected) {
            fieldClassName = fieldClassName.concat(' field--filled');
        }

        return super.handleClasses().concat(' ' + fieldClassName);
    }
    getSelected() {
        const { options, value } = this.props;
        return options.find((item, index) => item.value === value);
    }
    renderOptions() {
        const { options } = this.props;
        return options.map((item, index) => {
            return (
                <option key={index} value={item.value}>
                    {item.label}
                </option>
            );
        });
    }
    renderEmptyOption() {
        const { emptyValue } = this.props;

        if (emptyValue) {
            return <option value=''>{emptyValue}</option>;
        }

        return null;
    }
    renderAutoresize() {
        const { placeholder, autoResize } = this.props;
        const selected = this.getSelected();
        const label = selected ? selected.label : null;
        if (!autoResize) return null;
        return (
            <div className='field__input field__input--autoresize'>
                {label || placeholder}
            </div>
        );
    }
    render() {
        const {disabled} = this.props
        return (
            <label
                className={this.handleClasses()}
                data-label={super.renderAnimatedLabel()}
                ref={(r) => (this.field = r)}
            >
                {super.renderTooltip()}
                {super.renderLabel()}
                {this.renderAutoresize()}
                <select
                    disabled = {disabled}
                    className='field__input'
                    ref={(r) => (this.input = r)}
                    {...super.generateProps()}
                >
                    {this.renderEmptyOption()}
                    {this.renderOptions()}
                </select>
                {super.renderError()}
                {super.renderLoading()}
            </label>
        );
    }
}

export default FieldSelect;
